export const DEFAULT_PAGE_DESCRIPTION = 'Hackster is a community dedicated to learning hardware, from beginner to pro. Share your projects and learn from other developers. Come build awesome hardware!';
export const DEFAULT_PAGE_TITLE = 'Hackster.io - The community dedicated to learning hardware.';
